var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "search-picker" }, [
    _c(
      "div",
      {
        ref: "searchContainer",
        staticClass: "search-picker__search-container",
        class: {
          "search-picker__search-container--full-width": _vm.fullWidth,
          "search-picker__search-container--with-icon": _vm.withIcon,
        },
      },
      [
        _vm.withIcon
          ? _c("div", { staticClass: "search-picker__search-icon" }, [
              _c("i", { staticClass: "fa fa-search" }),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.searchText,
              expression: "searchText",
            },
          ],
          ref: "searchInput",
          staticClass: "search-picker__search",
          class: {
            "search-picker__search--full-width": _vm.fullWidth,
            "search-picker__search--with-icon": _vm.withIcon,
          },
          attrs: {
            id: _vm.inputId,
            placeholder: _vm.placeholder,
            "aria-owns": "search-picker-list",
            "aria-expanded": _vm.showingList ? "true" : "false",
            role: "combobox",
            "aria-autocomplete": "list",
            autocomplete: "off",
          },
          domProps: { value: _vm.searchText },
          on: {
            focus: _vm.showList,
            keydown: [
              function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "down", 40, $event.key, [
                    "Down",
                    "ArrowDown",
                  ])
                )
                  return null
                return _vm.descendHighlighted.apply(null, arguments)
              },
              function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "up", 38, $event.key, [
                    "Up",
                    "ArrowUp",
                  ])
                )
                  return null
                return _vm.ascendHighlighted.apply(null, arguments)
              },
              function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                )
                  return null
                $event.preventDefault()
                return _vm.selectHighlighted.apply(null, arguments)
              },
              function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "esc", 27, $event.key, [
                    "Esc",
                    "Escape",
                  ])
                )
                  return null
                return _vm.hideList.apply(null, arguments)
              },
            ],
            input: function ($event) {
              if ($event.target.composing) return
              _vm.searchText = $event.target.value
            },
          },
        }),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.showingList,
            expression: "showingList",
          },
        ],
        ref: "listContainer",
        staticClass: "search-picker__options",
        class: _vm.fullWidth ? "w-full" : "w-3/4",
      },
      [
        _vm.fetching
          ? _c(
              "div",
              { staticClass: "search-picker__list spacer-y-3 margin-y-1" },
              [
                _c("span", { staticClass: "spacer-x-3" }, [
                  _vm._v("Loading..."),
                ]),
              ]
            )
          : _c(
              "ul",
              {
                ref: "list",
                staticClass: "search-picker__list spacer-y-2 margin-y-1",
                attrs: { id: "search-picker-list" },
              },
              [
                _vm._l(_vm.options, function (option, index) {
                  return _c(
                    "li",
                    {
                      key: option.id,
                      ref: `option-${option.id}`,
                      refInFor: true,
                      staticClass:
                        "search-picker__list-item flex flex-col spacer-y-1",
                      class: {
                        "search-picker__list-item--highlight":
                          _vm.isHighlighted(index),
                      },
                      attrs: {
                        tabindex: "-1",
                        "aria-selected": _vm.isHighlighted(index)
                          ? "true"
                          : "false",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.selectOption(option)
                        },
                      },
                    },
                    [
                      _c("div", {
                        domProps: {
                          innerHTML: _vm._s(_vm.colourSearchTerm(option.name)),
                        },
                      }),
                      _vm._v(" "),
                      _vm._t("list-item-content", null, { option: option }),
                    ],
                    2
                  )
                }),
                _vm._v(" "),
                _vm.customOption && _vm.canAdd
                  ? _c(
                      "li",
                      { staticClass: "search-picker__list-item spacer-y-1" },
                      [
                        _c(
                          "button",
                          {
                            staticClass: "search-picker__button",
                            attrs: { type: "button" },
                            on: { click: _vm.addCustom },
                          },
                          [
                            _c("div", [
                              _vm._v("\n            Add ‘"),
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "search-picker__button--highlight",
                                },
                                [_vm._v(_vm._s(_vm.customOption))]
                              ),
                              _vm._v("’\n          "),
                            ]),
                          ]
                        ),
                      ]
                    )
                  : _vm.customOption && !_vm.canAdd
                  ? _c(
                      "li",
                      { staticClass: "search-picker__list-item spacer-y-1" },
                      [
                        _vm._v(
                          "\n        No results, check for typos and search again\n      "
                        ),
                      ]
                    )
                  : _vm._e(),
              ],
              2
            ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "sr-only",
            attrs: { "aria-live": "polite", role: "status" },
          },
          [
            _vm._v(
              "\n      " +
                _vm._s(_vm.options.length) +
                " results available.\n    "
            ),
          ]
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }